import { API_BASE_HOST, BASE_HOST } from "../../config/config";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import md5 from "js-md5";

// import router from "@/router";
const state = () => ({
  nickname: "",
  Info: {},
  tipMsg: {
    show: false,
    msg: ""
  }
});
const mutations = {
  setEssentialInfo(state, Info) {
    state.Info = Info;
  },
  setTipMsg(state, tipMsg) {
    state.tipMsg = tipMsg;
  },
  setnickname(state, nickname) {
    state.nickname = nickname;
  }
};

//配置
const config = {
  tipMessage({ commit, dispatch }, { context }) {
    const tmsg = {
      show: true,
      msg: context
    };
    commit("setTipMsg", tmsg);

    setTimeout(() => {
      commit("setTipMsg", {
        ...tmsg,
        show: false
      });
    }, 2000);
  }
};

const getSign = params => {
  const parts = [];
  if (params) {
    const keys = Object.keys(params).sort();
    for (const key of keys) {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        parts.push(`${key}=${value}`);
      }
    }
    const str = parts.join("&");
    return md5(str).toString();
  }
  return "";
};

//用户
const user = {
  async myPost($axios, url, ...postData) {
    var res = await $axios.post(
      url,
      {
        ...postData[0],
        lang: localStorage.getItem("mp_lang"),
        accessToken: localStorage.getItem("mp_accessToken") || "none"
      },
      {
        headers: {
          Authorization: localStorage.getItem("mp_accessToken") || "none",
          sign: getSign(postData[0])
        }
      }
    );
    return res;
  },
  async myPut($axios, url, ...postData) {
    var res = await $axios.put(
      url,
      {
        ...postData[0],
        lang: localStorage.getItem("mp_lang"),
        accessToken: localStorage.getItem("mp_accessToken") || "none"
      },
      {
        headers: {
          Authorization: localStorage.getItem("mp_accessToken") || "none",
          sign: getSign(postData[0])
        }
      }
    );
    return res;
  },

  async myGet($axios, url, ...postData) {
    var res = await $axios.get(url, {
      headers: {
        token: localStorage.getItem("mp_accessToken") || "none",
        Authorization: localStorage.getItem("mp_accessToken") || "none",
        "Accept-Language": localStorage.getItem("mp_lang"),
        sign: getSign(postData[0])
      },
      params: {
        ...postData[0]
      }
    });
    return res;
  },

  //创建帐号接口
  async Create({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/user-center/register`,
      {
        appId: "sgnbtgano1124cad5d6fe64b55862adb",
        ...postData
      }
    );

    if (res.data.code == 200) {
      localStorage.setItem("mp_accessToken", res.data.data.accessToken);
      localStorage.setItem("mp_refreshToken", res.data.data.refreshToken);
      await dispatch("getUserInfo", {
        $axios
      });
    }

    return res.data;
  },

  //发送验证码接口
  async SendVfCode({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/user-center/verify-code/email?email=${postData.email}&grantType=${postData.grantType}`
    );

    console.log("SendVfCode", res);
    return res.data;
  },

  // 登录接口
  async Login({ state, commit, dispatch }, { $axios, ...postData }) {
    const fp = await FingerprintJS.load();
    let fpId = (await fp.get()).visitorId;
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/user-center/login`,
      {
        appId: "sgnbtgano1124cad5d6fe64b55862adb",
        timestamp: new Date().getTime(),
        fpId,
        type: 1,
        ...postData
      }
    );

    if (res.data.code == 200) {
      localStorage.setItem("mp_accessToken", res.data.data.accessToken);
      localStorage.setItem("mp_refreshToken", res.data.data.refreshToken);
      await dispatch("getUserInfo", {
        $axios
      });
    }

    return res.data;
  },

  // 新版获取用户信息
  async getUserInfo({ state, commit, dispatch }, { $axios, reload = false }) {
    const res = await actions.myGet(
      $axios,
      `${BASE_HOST}/api/v1/user-center/user-info/full`,
      {}
    );
    if (res.data.code == 200) {
      localStorage.setItem("mp_nickname", res.data.data.nickname);
      localStorage.setItem("roleName", res.data.data.roleName);

      commit("setnickname", res.data.data.nickname);
      if (res.data.data.extInfo.baseInfo) {
        localStorage.setItem("groupType", "groupType");
      } else {
        localStorage.setItem("groupType", null);
      }
    }

    return res.data;
  },

  // 忘记密码接口
  async ForgotPass({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${BASE_HOST}/api/v1/user-center/password/reset`,
      {
        ...postData,
        appId: "sgnbtgano1124cad5d6fe64b55862adb"
      }
    );

    return res.data;
  },
  // 修改密码
  async EditPass(
    { state, commit, dispatch },
    { $axios, reload = false, ...postData }
  ) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/user-center/password`,
      {
        ...postData
      }
    );

    return res.data;
  },

  // 保存基本信息
  async EssentialInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const info = {
      ...postData
    };
    commit("setEssentialInfo", info);
    return;
  },

  // 更新基本信息
  async updateUserInfoExt(
    { state, commit, dispatch },
    { $axios, ...postData }
  ) {
    const res = await actions.myPut(
      $axios,
      `${BASE_HOST}/api/v1/user-center/user-info/ext`,
      {
        ...postData
      }
    );
    await dispatch("getUserInfo", {
      $axios
    });
    return res.data;
  },

  // 获取认证信息
  async GroupIdInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampGroup/GroupIdInfo`,
      {
        ...postData
      }
    );
    console.log("GroupIdInfo", res);
    return res.data;
  },

  // 提交身份信息审核
  async CensorIdInfo({ state, commit, dispatch }, { $axios, ...postData }) {
    const res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampGroup/CensorIdInfo`,
      {
        ...postData
      }
    );
    console.log("CensorIdInfo", res);
    return res.data;
  },

  // 这个是图片上传的接口
  async FileUpload({ state, commit, dispatch }, { $axios, file }) {
    console.log("filefilefile111", file);
    let config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    const formData = new FormData();
    formData.append("file", file);
    let res = await $axios.post(
      API_BASE_HOST +
        "/tgampGroup/FileUploadToS3?token=" +
        localStorage.getItem("mp_accessToken"),
      formData,
      config
    );
    if (res.data.stateCode == -1) {
      let Tokenres = await $axios.post(
        `${API_BASE_HOST}/tgampGroup/RefreshToken`,
        {
          refreshToken: localStorage.getItem("mp_refreshToken") || ""
        }
      );
      if (Tokenres.data.stateCode == -1) {
        let lang = localStorage.getItem("mp_lang");
        localStorage.clear();
        localStorage.setItem("mp_lang", lang);
        window.history.go(0);
      } else {
        localStorage.setItem(
          "mp_accessToken",
          Tokenres.data.resultInfo.data.accessToken
        );
        localStorage.setItem(
          "mp_refreshToken",
          Tokenres.data.resultInfo.data.refreshToken
        );
        res = await $axios.post(
          API_BASE_HOST +
            "/tgampGroup/FileUploadToS3?token=" +
            localStorage.getItem("mp_accessToken"),
          formData,
          config
        );
      }
    }
    console.log("FileUpload", res);
    return res.data;
  },

  // 上传文件

  async FileUnZip({ state, commit, dispatch }, { $axios, file }) {
    console.log("filefilefile111", file);
    let config = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    const formData = new FormData();
    formData.append("file", file);
    let res = await $axios.post(
      API_BASE_HOST +
        "/tgampGroup/FileUnZipToS3?token=" +
        localStorage.getItem("mp_accessToken"),
      formData,
      config
    );
    if (res.data.stateCode == -1) {
      let Tokenres = await $axios.post(
        `${API_BASE_HOST}/tgampGroup/RefreshToken`,
        {
          refreshToken: localStorage.getItem("mp_refreshToken") || ""
        }
      );
      if (Tokenres.data.stateCode == -1) {
        let lang = localStorage.getItem("mp_lang");
        localStorage.clear();
        localStorage.setItem("mp_lang", lang);
        window.history.go(0);
      } else {
        localStorage.setItem(
          "mp_accessToken",
          Tokenres.data.resultInfo.data.accessToken
        );
        localStorage.setItem(
          "mp_refreshToken",
          Tokenres.data.resultInfo.data.refreshToken
        );
        res = await $axios.post(
          API_BASE_HOST +
            "/tgampGroup/FileUnZipToS3?token=" +
            localStorage.getItem("mp_accessToken"),
          formData,
          config
        );
      }
    }
    console.log("FileUnZip", res);
    return res.data;
  },
  // 文件解压缩接口
  async FileState({ state, commit, dispatch }, { $axios, ...postData }) {
    console.log("postData", postData);
    let res = await actions.myPost(
      $axios,
      `${API_BASE_HOST}/tgampGroup/FileState`,
      {
        ...postData,
        token: localStorage.getItem("mp_accessToken")
      }
    );

    console.log("FileState", res);
    return res.data;
  }
};

const actions = {
  ...config,
  ...user
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js